export default __webpack_public_path__ + "assets/images/12d26db94e0d944abdd249a3337fa115.svg";